// to easily copy and paste components
import {useMemo, useState} from 'react';
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import {useTranslation} from 'react-i18next';
import Select from 'react-select';
import {selectCustomStyles} from '../../common/shared/select.styled';
import deleteCheckRowIcon from '../../images/new-dlt.png';
import Table from '../../common/table/TableFunctional';
import BllinkUtils from '../../common/utils/utils';
import {StyledExpensesTable} from './expenses.styled';

export default function ExpensesRecordTable({expenseRows, onChangeExpenseType, onRemoveLineClick, setTableData, disableActions}) {
    const {t} = useTranslation();
    const [skipPageReset, setSkipPageReset] = useState(false);

    const onDeleteClick = (rowIndex) => {
        BllinkLogger.info(`expense row delete ${rowIndex}`)
        onRemoveLineClick(rowIndex);
    }

    const updateTableData = (rowIndex, columnId, value) => {
        let isValid = true;
        let error = '';

        if (columnId === 'amount') {
            isValid = BllinkUtils.JsExtras.isNumeric(value) && value > 0;
            error = isValid ? '' : t('reports.fieldError', {field: columnId});
        }

        setSkipPageReset(true);
        setTableData(rowIndex, columnId, value, error);
    }

    const columns = useMemo(
        () => [
            {
                Header: t('expenses.expense_record_table_index'),
                id: 'index',
                Cell: ({row}) => (
                    <span>
                        {row.index + 1}
                    </span>
                ),
            },
            {
                Header: t('expenses.expense_record_table_type'),
                accessor: 'expenseTypes',
                Cell: ({row, value}) => {
                    const selectVal = value?.expenseTypeID.value ? value?.expenseTypeID : value?.all[0];
                    return (
                        <Select
                            id={`expense-type-${row.index}`}
                            className={'js-expense-type'}
                            styles={selectCustomStyles}
                            options={value ? value.all : []}
                            value={selectVal}
                            menuPortalTarget={document.querySelector('body')}
                            onChange={val => onChangeExpenseType(val, row.index)}
                        />
                    )
                },
                minWidth: 200
            },
            {
                Header: t('expenses.expense_record_table_description'),
                accessor: 'description',
                minWidth: 380
            },
            {
                Header: t('expenses.expense_record_table_amount'),
                accessor: 'amount',
                minWidth: 200
            },
            {
                Header: t('expenses.expense_record_table_actions'),
                id: 'actions',
                Cell: ({row}) => {
                    const deleteIcon = row.index > 0 ? <img alt="delete-row" src={deleteCheckRowIcon}/> : '';
                    return (
                        <div>
                            <div
                                className="js-remove-expense-row"
                                onClick={() => onDeleteClick(row.index)}
                            >
                                {deleteIcon}
                            </div>
                        </div>
                    );
                },
            },
        ],
        [expenseRows]
    );

    const tableData = useMemo(() => expenseRows, [expenseRows]);

    return (
        <StyledExpensesTable>
            {
                tableData.length > 0 && (
                    <Table
                        className="expenses-record-table"
                        columns={columns}
                        data={tableData}
                        updateData={updateTableData}
                        skipPageReset={skipPageReset}
                        tableTitle={t('expenses.expense_record_table_title')}
                        hiddenColumns={disableActions ? ['actions'] : []}
                    />
                )
            }
        </StyledExpensesTable>
    );
}


